<ng-container>
    @if(isPageRestrictionLoaded){
    <div class="ppl-container-body" style="margin-top: -10px">
        <div class="ppl-container">
            <div class="ppl-content-container">
                <div class="action add-btn">
                </div>
                <div class="w-100">
                    <ppl-claim-adjustment-filter (searchEvent)="onSearch($event)" [filterFields]="fields"
                        [adjustType]="'single'"></ppl-claim-adjustment-filter>
                </div>

                <div class="table-style">
                    @if(claimsData.length > 0) {
                    <ppl-list-table [customDataLoaded]="true" [disableSearch]="true" [showCustomSearch]="false"
                        [cols]="cols" [enableActions]="true" [data]="claimsData" (gridAction)="rowActions($event)"
                        (rowDetailEvent)="rowClicked($event)" [disableSelection]="true" [gridTitle]="false"
                        [buttonConfig]="buttonConfig" [pagination]="true" [loadPage]="true"
                        (onPageLoad)="onPageLoad($event)" [from]="'claimsAdjustment'">
                    </ppl-list-table>
                    } @else {
                    <div class="alert alert-warning"><strong>No Records Found. </strong>Please change the filters to
                        find the records</div>
                    }
                </div>
            </div>
        </div>
    </div>
    }
</ng-container>

<div class="filter-panel">
    <ng-template #viewTimesheetsDialog let-cancel="cancel">
        <ppl-view-timesheets [claimDetailId]="claimDetailId"></ppl-view-timesheets>
    </ng-template>
</div>

<div class="filter-panel">
    <ng-template #adjustMCODialog let-cancel="cancel">
        <ppl-adjust-service-claim [claimDetails]="claimDetails" [programName]="programName" [adjustType]="'mco'"
            (cancel)="cancel()"></ppl-adjust-service-claim>
    </ng-template>
</div>

<div class="filter-panel">
    <ng-template #adjustServiceClaimDialog let-cancel="cancel">
        <ppl-adjust-service-claim [claimDetails]="claimDetails" [programName]="programName" [adjustType]="'service'"
            (cancel)="cancel($event)"></ppl-adjust-service-claim>
    </ng-template>
</div>